import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (c) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...c,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m50.48 46.54 5.6 5.6c3.05-4.84 2.47-11.32-1.75-15.54a12.477 12.477 0 0 0-8.86-3.67c-.39 0-.77.02-1.16.05l-13.3-13.3c.33-3.58-.88-7.28-3.62-10.02A12.491 12.491 0 0 0 18.53 6c-2.32 0-4.64.64-6.67 1.92l5.6 5.6-.83 3.11-3.11.83-5.6-5.6C4.87 16.7 5.45 23.18 9.67 27.39c2.45 2.45 5.65 3.67 8.86 3.67.39 0 .77-.02 1.16-.05l13.3 13.3c-.33 3.58.88 7.28 3.62 10.02 2.45 2.45 5.65 3.67 8.86 3.67 2.32 0 4.64-.64 6.67-1.92l-5.6-5.6.83-3.11 3.11-.83Zm-4.14-3.03-2.23.6-.6 2.23-.83 3.11-.6 2.23 1.63 1.63.62.62a8.44 8.44 0 0 1-4.9-2.42c-1.8-1.8-2.7-4.29-2.46-6.82l.17-1.87-1.33-1.33-13.3-13.3-1.33-1.33-1.87.17c-.26.02-.53.04-.79.04-2.28 0-4.42-.89-6.03-2.5a8.383 8.383 0 0 1-2.42-4.9l.62.62 1.63 1.63 2.23-.6 3.11-.83 2.23-.6.6-2.23.83-3.11.6-2.23-1.63-1.63-.62-.62a8.44 8.44 0 0 1 4.9 2.42c1.8 1.8 2.7 4.29 2.46 6.82l-.17 1.87 1.33 1.33 13.3 13.3 1.33 1.33 1.87-.17c.26-.02.53-.04.79-.04 2.28 0 4.42.89 6.03 2.5a8.383 8.383 0 0 1 2.42 4.9l-.62-.62-1.63-1.63-2.23.6-3.11.83Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m25.546 24.003-1.415 1.415L39.454 40.74l1.414-1.414-15.323-15.323Z"
        }
      )
    ]
  }
);
export {
  t as Wrench
};
